import React, { useEffect, useState } from 'react';

import { BallotsTimeline } from './components/admin/BallotsTimeline';
import { ArchiveBallots } from './components/admin/ArchiveBallots';
import { Switch, Route } from 'react-router';
import axios from 'axios';
import { Ballots } from './components/admin/Ballots';
import { Sidebar } from './components/portal/Sidebar';
import { RoutePage } from './components/portal/RoutePage';
import { LoadingPanel } from './components/common/LoadingPanel';
import { IUserInfo, IUserMenuItem, PortalApiRoutes, PortalRoutes } from './types/portalTypes';
import { usePortalContext } from './contexts/PortalContext';

const PortalApp: React.FC = () => {
    const [isPageInit, setPageInit] = useState<boolean>(false)
    const [userMenu, setUserMenu] = useState<IUserMenuItem[]>()
    const { setLegacyBaseUrl } = usePortalContext();

    useEffect(() => {
        if (isPageInit) {
            return
        }

        // Retrieve user info (if not logged in the 403 will auto redirect to login page on first load)
        axios.get<IUserInfo>(PortalApiRoutes.USER_INFO)
            .then((response) => {
                setUserMenu(response.data.menu)
                setLegacyBaseUrl(response.data.legacyBaseUrl)
                setPageInit(true)
            })
            .catch((error: any) => {
                alert(error);
            })
    }, [isPageInit])

    return (
        <>
            {isPageInit ?
                <div className="flex">
                    <Sidebar userMenu={userMenu} onLoggedOut={() => setPageInit(false)} />
                    <div className="bg-panel flex-1 p-4">
                        <Switch>
                            <RoutePage path={PortalRoutes.BALLOTS_TIMELINE} title="Ballots Timeline">
                                <BallotsTimeline />
                            </RoutePage>
                            <RoutePage path={PortalRoutes.BALLOTS_ARCHIVE} title="Archive Ballots">
                                <ArchiveBallots />
                            </RoutePage>
                            <RoutePage path={PortalRoutes.BALLOTS_TEST} title="Test Ballots">
                                <Ballots isTest={true} />
                            </RoutePage>
                            <RoutePage path={PortalRoutes.BALLOTS} title="Ballots">
                                <Ballots isTest={false} />
                            </RoutePage>
                            <RoutePage path={PortalRoutes.HOME} title="Ballots">
                                <Ballots isTest={false} />
                            </RoutePage>
                        </Switch>
                    </div>
                </div>
                :
                <div className="container">
                    <LoadingPanel className="bg-white py-8 px-10 shadow sm:rounded-lg sm:mt-8 text-center"
                        isLoading={!isPageInit}
                        loadingText="Loading Portal..."
                    />
                </div>
            }
        </>
    )
}

export default PortalApp;